'use client';
import React from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Heading } from './Heading';

export const H2 = (props: TextT) => (
  <Heading
    as="h2"
    mb={['space4', 'space6']}
    fontSize={['175', '200', '225', '225']}
    {...props}
  />
);
